export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_title_displayImportMsg') || '错误/警告信息',
    field: 'displayImportMsg',
    headerAlign: 'center',
    align: 'left',
    width: 280,
    slots: { default: 'displayImportMsg' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_purchaseFabricNo') || '采购单号',
    field: 'purchaseFabricNo',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_originOrderNo') || '源头订单号',
    field: 'originOrderNo',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_scmName') || '供方',
    field: 'scmName',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_buyerName') || '采购人员',
    field: 'buyerName',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_purchaseDate') || '制单日期',
    field: 'purchaseDate',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_totalAmount') || '采购金额',
    field: 'totalAmount',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_detailFabric') || '采购面料',
    align: 'center',
    showHeaderOverflow: true,
    children: [
      {
        title: that.$l('form_label_detailFabric_fabricNo') || '物料编码',
        field: 'detail.fabricNo',
        align: 'center',
        minWidth: 120,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_detailFabric_fabricName') || '物料名称',
        field: 'detail.fabricName',
        align: 'center',
        minWidth: 150,
        showHeaderOverflow: true,
        showOverflow: true,
      },
      {
        title: that.$l('form_label_detailFabric_fabricContent') || '规格型号',
        field: 'detail.fabricContent',
        headerAlign: 'center',
        align: 'left',
        minWidth: 200,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_detailFabric_fabricWidth') || '有效门幅',
        field: 'detail.fabricWidth',
        align: 'center',
        minWidth: 120,
        showHeaderOverflow: true,
        formatter: ({ row }) => {
          return [row.detail.fabricWidth || '0', row.detail.fabricWidthUnitText]
            .filter(Boolean)
            .join(' ')
        },
      },
      {
        title: that.$l('form_label_detailFabric_fabricColor') || '颜色',
        field: 'detail.fabricColor',
        align: 'center',
        minWidth: 120,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_detailFabric_series') || '系列',
        field: 'detail.series',
        headerAlign: 'center',
        align: 'left',
        minWidth: 120,
        showOverflow: true,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_detailFabric_fabricWeight') || '克重',
        field: 'detail.fabricWeight',
        align: 'center',
        minWidth: 120,
        showHeaderOverflow: true,
        formatter: ({ row }) => {
          return [
            row.detail.fabricWeight || '0',
            row.detail.fabricWeightUnitText,
          ]
            .filter(Boolean)
            .join(' ')
        },
      },
      {
        title: that.$l('form_label_detailFabric_qty') || '数量',
        field: 'detail.qty',
        align: 'center',
        minWidth: 120,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_detailFabric_fabricUnit') || '单位',
        field: 'detail.fabricUnitText',
        align: 'center',
        minWidth: 80,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_detailFabric_unitPrice') || '含税单价',
        field: 'detail.unitPrice',
        align: 'center',
        minWidth: 120,
        showHeaderOverflow: true,
      },
      {
        title: that.$l('form_label_detailFabric_subAmount') || '价税合计',
        field: 'detail.subAmount',
        align: 'center',
        minWidth: 120,
        showHeaderOverflow: true,
      },
      {
        title:
          that.$l('form_label_detailFabric_planArrivalDate') || '计划到货日期',
        field: 'detail.planArrivalDate',
        align: 'center',
        minWidth: 120,
        showHeaderOverflow: true,
      },
    ],
  },
]
